module.exports = __webpack_public_path__ + "static/media/logo-aulao-vespera.c5ec045b.png";